import { HttpClient } from '@angular/common/http';
import { inject, Injectable, Inject } from '@angular/core';
import { ApiResponse } from '@app/shared/interfaces';
import { Business, BusinessPayload } from '../interfaces/business.interface';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { ProfitAndLoss } from '../interfaces/profit-and-loss.interface';
import { BusinessProperty } from '../interfaces/property.interface';
import { Filter } from '@app/shared/interfaces/lib/filter.interface';

@Injectable({
  providedIn: 'root',
})
export class MyBusinessApiService {
  private readonly baseUrl = `${environment.apiUrl}/businesses`;
  private readonly http = inject(HttpClient);

  constructor(@Inject('apiMetricsUrl') private apiMetricsUrl: string) {}

  /** Businesses */
  public createBusiness(business: BusinessPayload): Observable<Business> {
    return this.http.post<Business>(this.baseUrl, business);
  }

  public updateBusiness(businessUuid: Business['uuid'], business: BusinessPayload): Observable<Business> {
    return this.http.put<Business>(`${this.baseUrl}/${businessUuid}`, business);
  }

  public getBusiness(businessUuid: Business['uuid']): Observable<Business> {
    return this.http.get<Business>(`${this.baseUrl}/${businessUuid}`);
  }

  public getBusinesses(): Observable<ApiResponse<Business[]>> {
    return this.http.get<ApiResponse<Business[]>>(this.baseUrl);
  }

  public getPropertiesForBusiness(): Observable<BusinessProperty[]> {
    return this.http.get<BusinessProperty[]>(`${this.baseUrl}/properties`);
  }

  /** Profit and Loss */
  public getProfitAndLossReport(filters: Filter[] = []) {
    const payload = {
      filters: filters?.reduce(
        (acc, filter) => ({
          ...acc,
          [filter.key]: filter.initial_payload,
        }),
        {}
      ),
    };
    return this.http.post<{ data: ProfitAndLoss }>(`${this.baseUrl}/profit-and-loss`, payload);
  }
}
